import Vue from "vue";
import Vuex from "vuex";

import student from "./store/student";
Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    policies: [],
    departments: [],
    activeDepartment: {},
    student: student,
    filterOptions: {
      sign_mode: ["in"],
      first_name: "",
      last_name: "",
      from_date: new Date().toISOString().split("T")[0],
      to_date: new Date().toISOString().split("T")[0],
      checkbox: String,
      select: null
    }
  },
  mutations: {
    resetState(state) {
      state.departments = [];
      state.activeDepartment = {};
      state.filterOptions = {
        sign_mode: ["in"],
        first_name: "",
        last_name: "",
        from_date: new Date().toISOString().split("T")[0],
        to_date: new Date().toISOString().split("T")[0],
        checkbox: String,
        select: null
      };
    },
    resetStateResources(state) {
      state.activeDepartment = {};
    },
    setStudentSwitchState(state, status) {
      state.student.studentId = {
        action: status.action,
        payload: status.payload
      };
    },
    applyPolicies(state, options) {
      state.policies = options;
    },
    applyFilters(state, options) {
      state.filterOptions = options;
    },
    setDepartments(state, departments) {
      state.departments = departments;
    },
    setDepartment(state, department) {
      state.activeDepartment = department;
    },
    resetFilters(state) {
      state.filterOptions = {
        sign_mode: ["in"],
        first_name: "",
        last_name: "",
        from_date: new Date().toISOString().split("T")[0],
        to_date: new Date().toISOString().split("T")[0],
        checkbox: String,
        select: null
      };
    }
  },
  actions: {}
});
